module.exports = __webpack_public_path__ + "static/media/alpha_7.c6aef2f0.png";